import axios from "axios"
import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { CertTitle } from "./CertTitle"
import classes from './Certificate.module.css';
import { CertCompletion } from "./CertCompletion";
import { CertConfirm } from "./CertConfirm";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { CertForm } from "./V2/CertForm";

export const CertificateV2 = () => {
    const [t] = useTranslation("global");
    const selLanguage = useSelector((state: any) => state.selLanguage) as any;

    return (
        <>
            <Helmet>
                <title>{t("menu.certificates")} - {t("mainTag.title")}</title>
                <meta name="og:title" content={`${t("menu.certificates")} - ${t("mainTag.title")}`} />
                <meta name="description" content={"Какой подарок можно подарить, чтобы он навсегда остался с человеком? Ответ прост — дарите эмоции! Сертификаты «Ленинград Центра» позволят вам подарить визит на любое шоу в течение 1-го года с момента приобретения."} />
                <meta name="og:description" content={"Какой подарок можно подарить, чтобы он навсегда остался с человеком? Ответ прост — дарите эмоции! Сертификаты «Ленинград Центра» позволят вам подарить визит на любое шоу в течение 1-го года с момента приобретения."} />
                {/* <meta property="og:image" content={data.headLayoutImageType ? `/api/shows/head-wide-img/${data.id})` : "/Show/091A8332.jpg"} /> */}
            </Helmet>
            <CertTitle />
            <CertForm />

            <div className="d-flex justify-content-center">
                <div className="logoabr text-center"><img className="img-fluid" src="/Cert/logoabr.png" /></div>
                <div className={`${classes.cardPay} text-center`}>
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </>
    )
}
